export const PAYMENTS_CONFIG = {
  date: {
    key: "date",
    label: "Fecha"
  },
  balance: {
    key: "balance",
    label: "Saldo"
  },
  debit: {
    key: "debit",
    label: "Cargo"
  },
  payment: {
    key: "payment",
    label: "Pago"
  },
  total: {
    key: "total",
    label: "Total"
  },
  source: {
    key: "source",
    label: "Origen"
  },
  reference: {
    key: "reference",
    label: "Referencia"
  },
  status: {
    key: "status",
    label: "Estado"
  }
};

export const PAYMENTS_PHRASE = {
  page: {
    table: {
      title: "Histórico de Saldos",
      header: {
        dropdown: {
          noOptions: "No hay clientes",
          label: "Clientes"
        },
        button: "buscar",
        snackBar: "Selecciona un Cliente"
      }
    }
  },
  modal: {
    titles: {},
    actions: {
      cancel: "Cancelar",
      close: "Cerrar",
      add: "Agregar",
      delete: "Eliminar",
      save: "Guardar",
      submit: "Aceptar"
    },
    content: {}
  },
  search: {
    messages: {
      noStations: "No se ha seleccionado alguna planta."
    }
  },
  form: {
    dropdowns: {
      client: "Seleccione un Cliente",
      apartment: "Seleccione un Departamento",
      status: "Seleccione un Estado"
    }
  }
};
